import * as Yup from 'yup';
import { createPaginationSchema } from '@emfood/shared';

const SurplusListFilterSchema = Yup.object({
  distributorOrgId: Yup.string(),
  distributorSiteId: Yup.string(),
});

export const SurplusListSearchParamsSchema =
  SurplusListFilterSchema.concat(createPaginationSchema());
